import { FC } from "react";
import { Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";

import { DEFAULT_AUTHENTICATED_ROUTE } from "../../constants/routes";
import { useAuth } from "../../hooks/useAuth";
import { selectAuthIsRecovery } from "../../store/selectors/auth";

const PublicRoute: FC = () => {
  const { isInitialized, isAuthenticated, paymentStatus } = useAuth();
  const isRecovery = useSelector(selectAuthIsRecovery);

  if (!isInitialized) {
    return null;
  }

  if (isAuthenticated && paymentStatus === 'paid' && !isRecovery) {
    return <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
